
export type INumberValue = string | number | null | undefined;


export const isNotNull = (value: INumberValue) => {
    return Number(value) || 0;
  };

export function displayPriceFormat(value: string | number | null) {
  const num = Number(isNotNull(value));
  return num.toLocaleString("en-IN");
}